import React, { useState, useEffect } from "react";
import { Container, Row, Col, Nav, Tab, Card } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import { Link, useNavigate } from "react-router-dom";
import { gettravelPackageList } from "../store/slices/tourpackage";
import AOS from "aos";
import "aos/dist/aos.css";
import { useDispatch } from "react-redux";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const PackageSkeleton = () => {
  return (
    <Card className="tour-card shadow-sm border-0">
      {/* Image Skeleton */}
      <Skeleton height={180} className="mb-2" />

      <Card.Body>
        {/* Title */}
        <Skeleton height={20} width="80%" className="mb-2" />

        {/* Location */}
        <Skeleton height={14} width="70%" className="mb-2" />

        {/* Duration */}
        <Skeleton height={14} width="50%" />

        {/* Footer */}
        <div className="d-flex justify-content-between align-items-center mt-3">
          <Skeleton height={18} width={80} />
          <Skeleton height={14} width={60} />
        </div>
      </Card.Body>
    </Card>
  );
};

export default function Travelpackage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [key, setKey] = useState("budget");
  const [packages, setPackages] = useState([]);
  const [loading, setLoading] = useState(false);

  const categoryMap = {
    budget: "budget-packages",
    family: "family-package",
    honeymoon: "honeymoon-package",
    group: "group-tour-package",
  };

  useEffect(() => {
    AOS.init({ duration: 1000, once: true, easing: "ease-out-cubic" });
  }, []);

  const fetchPackages = async () => {
    setLoading(true);

    try {
      const slug = categoryMap[key];

      const res = await dispatch(
        gettravelPackageList({
          categorySlug: slug,
          page: 1,
          limit: 4,
        })
      ).unwrap();

      const items = res?.packages?.packageData || [];
      setPackages(items.slice(0, 4));
    } catch (err) {
      console.error("Error fetching:", err);
      setPackages([]);
    }

    setLoading(false);
  };

  useEffect(() => {
    fetchPackages();
  }, [key]);

  const openDetails = (item) => {
    navigate(`/package-details/${item.slug}`);
  };

  return (
    <section className="tour-packages-section py-6 container-fluid">
      <Container>
        <div className="text-center mb-4" data-aos="fade-down">
          <h2 className="mt-3 new-font">Popular Tour Packages</h2>
          <h2
            className="fw-bold mb-4"
            style={{ fontSize: "38px", color: "#000" }}
          >
            Something Amazing Waiting For You
          </h2>
        </div>

        <Tab.Container activeKey={key} onSelect={(k) => setKey(k)}>
          <div
            className="tabs-wrapper mx-auto"
            data-aos="fade-up"
            data-aos-delay="200"
          >
            <Nav variant="tabs" className="custom-tabs mb-4">
              <Nav.Item>
                <Nav.Link eventKey="budget">
                  <i className="bi bi-send me-2"></i>Budget
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="family">
                  <i className="bi bi-building me-2"></i>Family
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="honeymoon">
                  <i className="bi bi-cup-hot me-2"></i>Honeymoon
                </Nav.Link>
              </Nav.Item>

              <Nav.Item>
                <Nav.Link eventKey="group">
                  <i className="bi bi-house-door me-2"></i>Group
                </Nav.Link>
              </Nav.Item>
            </Nav>
          </div>

          <Tab.Content>
            <Tab.Pane eventKey={key}>
              <Row className="gy-4 mt-2">
                {loading ? (
                  <Row className="gy-4 mt-2">
                    {[...Array(4)].map((_, index) => (
                      <Col md={6} lg={3} key={index}>
                        <PackageSkeleton />
                      </Col>
                    ))}
                  </Row>
                ) : packages.length ? (
                  packages.map((item, index) => (
                    <Col
                      md={6}
                      xs={6}
                      xm={6}
                      lg={3}
                      key={index}
                      data-aos="zoom-in"
                      data-aos-delay={index * 120}
                    >
                      <Link to={`/package-details/${item.slug}`}>
                        <Card
                          className="tour-card shadow-sm border-0"
                          onClick={() => openDetails(item)}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={
                              item.images?.[0]?.mediaLink ||
                              "https://via.placeholder.com/400x250"
                            }
                            className="tour-img"
                            alt={item.packageName}
                          />

                          <Card.Body>
                            <p className="pkg-title">{item.packageName}</p>

                            <Card.Text className="text-muted">
                              <i className="bi bi-geo-alt-fill text-primary me-1"></i>

                              {(() => {
                                const placeNames =
                                  item.places?.map((p) => p.name) || [];
                                const firstTwo = placeNames
                                  .slice(0, 2)
                                  .join(", ");
                                const rest =
                                  placeNames.length > 2
                                    ? ` + ${placeNames.length - 2} more places`
                                    : "";
                                return firstTwo + rest;
                              })()}
                            </Card.Text>

                            <Card.Text className="text-muted">
                              <i className="bi bi-calendar-event text-primary me-1"></i>
                              {item.duration}
                              <div className="rating mt-2 d-flex d-lg-none d-md-none align-items-center">
                                <i className="bi bi-star-fill text-warning me-1 "></i>
                                <i className="bi bi-star-fill text-warning me-1"></i>
                                <i className="bi bi-star-fill text-warning me-1"></i>
                                <i className="bi bi-star-fill text-warning me-1"></i>
                                <i className="bi bi-star-fill text-warning me-1"></i>
                              </div>
                            </Card.Text>

                            <div className="d-flex justify-content-between align-items-center mt-3">
                              <div className="price-box">
                                <span className="price">
                                  ₹ {Math.round(item.packagebaseRate / 2)}
                                </span>
                                <span className="per-person">/ Person</span>
                              </div>

                              <div className="rating d-none d-lg-flex d-md-flex align-items-center">
                                <i className="bi bi-star-fill text-warning me-1 "></i>
                                <i className="bi bi-star-fill text-warning me-1"></i>
                                <i className="bi bi-star-fill text-warning me-1"></i>
                                <i className="bi bi-star-fill text-warning me-1"></i>
                                <i className="bi bi-star-fill text-warning me-1"></i>
                              </div>
                            </div>
                          </Card.Body>
                        </Card>
                      </Link>
                    </Col>
                  ))
                ) : (
                  <p className="text-center mt-4">No packages found</p>
                )}
              </Row>
            </Tab.Pane>
          </Tab.Content>
        </Tab.Container>
      </Container>
    </section>
  );
}
